const ProductCartIcon = (props) => (
  <svg
    width={14}
    height={16}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8069 3.90558H10.1907V3.25465C10.1907 1.43205 8.71496 0 6.83669 0C4.95843 0 3.48265 1.43205 3.48265 3.25465V6.5093H4.82427V5.20744H7.5075V3.90558H4.82427V3.25465C4.82427 2.14807 5.69632 1.30186 6.83669 1.30186C7.97707 1.30186 8.84912 2.14807 8.84912 3.25465V6.5093H10.1907V5.20744H11.5994L12.2032 14.3205H1.5373L2.07395 5.20744H2.14103V3.90558H0.866494L0.0615234 15.6223H13.5448L12.8069 3.90558Z"
      fill="currentColor"
    />
  </svg>
);
export default ProductCartIcon;
